/**
 * Show Dynamics API service for admin interface
 * Handles operations for show dynamics
 */

import type { ShowDynamics } from '@musedrops/shared';
import { getAllShowDynamics } from '../data/showDynamics';

export class ShowDynamicsApi {
  static async getAll(): Promise<ShowDynamics[]> {
    return getAllShowDynamics();
  }

  static async getByKey(key: string): Promise<ShowDynamics | null> {
    const allDynamics = await ShowDynamicsApi.getAll();
    return allDynamics.find(d => d.key === key) || null;
  }

  /**
   * Format dynamics for use in prompt templates
   * Returns formatted string: "- key: good_for\n- key2: good_for2\n..."
   *
   * Example:
   * - teller-sidekick: One host tells stories, the other reacts and asks questions
   * - interview: Traditional interview format with host and guest
   */
  static async formatForPrompt(): Promise<string> {
    const dynamics = await ShowDynamicsApi.getAll();

    if (dynamics.length === 0) {
      return '(No dynamics available)';
    }

    return dynamics.map(d => `- ${d.key}: ${d.goodFor}`).join('\n');
  }
}
